import { EventEmitter } from '@angular/core';
import { Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClientCustom } from './http.client';
import { Configuration } from './configuration';
import { Router } from '@angular/router';
import 'rxjs';
import { AllHtmlEntities } from 'html-entities';
var Auth = /** @class */ (function () {
    function Auth(httpClient, _global, router) {
        this.httpClient = httpClient;
        this._global = _global;
        this.router = router;
        this.updateProfilePic = new EventEmitter();
        this.closeFilterValue = new EventEmitter();
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._biUrl = _global.get('BI_BASE_URL');
        this._appUrl = _global.get('USER_APP_URL');
    }
    Object.defineProperty(Auth.prototype, "isAuthenticated", {
        get: function () {
            if (window.localStorage.getItem('activeToken')) {
                return true;
            }
            else {
                this._userInfo = '';
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "userInfo", {
        get: function () {
            return this._userInfo;
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line:member-access
    Auth.prototype.login = function (username, password) {
        var _this = this;
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.httpClient.post(this._baseUrl + 'login?username='
            + username + '&password=' + password, {}, { headers: headers }).subscribe(function (response) {
            // login successful if there's a jwt token in the response
            if (window.localStorage.getItem('activeToken')) {
                _this.router.navigate(['/hub']);
            }
            return true;
        }, function (err) {
            //  this.translate.get('incorrectValues').subscribe((msg)=>{
            alert('incorrectValues');
            // })
        });
    };
    // tslint:disable-next-line:member-access
    Auth.prototype.user = function () {
        if (this._userInfo) {
            return this.createObservable(this._userInfo);
        }
        var self = this;
        return this.httpClient.get(this._baseUrl + 'v1/hub/employeeInfo').map(function (result) {
            self._userInfo = result;
            window.localStorage.setItem('userInfo', JSON.stringify(result));
            return self._userInfo;
        });
    };
    // tslint:disable-next-line:member-access
    Auth.prototype.logout = function () {
        // window.localStorage.removeItem('userInfo');
        // window.localStorage.removeItem('activeToken');
        // let url = this._baseUrl + 'v1/hub/logout';
        // this.httpClient.post(url, {}).subscribe();
        // window.location.href = this._appUrl;
        var _this = this;
        this._userInfo = '';
        var url = this._baseUrl + 'v1/hub/logout';
        this.httpClient.get(url).subscribe(function (result) {
            _this.clearLocalStorage();
            window.location.href = _this._appUrl + "/";
        }, function (err) {
            _this.clearLocalStorage();
            if (err.status == 200) {
                window.location.href = err.headers.get("location");
            }
            else {
                window.location.href = _this._appUrl + "/";
            }
        });
    };
    Auth.prototype.clearLocalStorage = function () {
        window.localStorage.clear();
    };
    Auth.prototype.createObservable = function (data) {
        return Observable.create(function (observer) {
            observer.next(data);
            observer.complete();
        });
    };
    Auth.prototype.handleError = function (error) {
        console.log(error);
        // return false;
        return Observable.throw(error || 'Server error');
    };
    Object.defineProperty(Auth.prototype, "userImage", {
        get: function () {
            return (this._userInfo && this._userInfo.imageUrl) ? this._userInfo.imageUrl : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "tenantImage", {
        get: function () {
            var self = this;
            if (!this._tenantLogo) {
                return this.httpClient.get(this._baseUrl + 'v1/hub/tenantLogo')
                    .map(function (res) {
                    var img = res;
                    if (img && img.id) {
                        self._tenantLogo = img.id;
                    }
                    return self._tenantLogo;
                }).catch(self.handleError);
            }
            else {
                return self.createObservable(self._tenantLogo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "tenant", {
        get: function () {
            var self = this;
            if (!this._tenant) {
                return this.httpClient.get(this._baseUrl + '/v2/tenant/getBiLogo')
                    .map(function (res) {
                    self._tenant = res;
                    return self._tenant;
                }).catch(self.handleError);
            }
            else {
                return self.createObservable(self._tenant);
            }
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line:member-ordering
    Auth.prototype.htmlEntitiesDecode = function (message) {
        try {
            var entities = new AllHtmlEntities();
            return entities.decode(message);
        }
        catch (e) {
            console.log('Error in htmlEntitiesDecode::', e);
        }
    };
    Auth.prototype.closeFilter = function () {
        this.closeFilterValue.emit();
    };
    Auth.prototype.updateUser = function (userInfo) {
        this._userInfo = userInfo;
        console.log(this._userInfo);
        this.setUserInfo(this._userInfo);
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.updateProfilePic.emit(userInfo);
    };
    Auth.prototype.setUserInfo = function (data) {
        window.localStorage.setItem('userInfo', JSON.stringify(data));
    };
    return Auth;
}());
export { Auth };



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.ts.pre-build-optimizer.js